import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import apiClient from '../api/client';

const API_BASE_URL = sessionStorage.getItem("API_BASE_URL");

function NotesTab({ ticketId, domain }) {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    createdOn: '',
    createdBy: '',
    text: ''
  });

  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchNotes = async () => {
      try {
        const res = await apiClient.post(`/api/tickets/notes`, {
          domain, ticketId });
        setNotes(res.data || []);
      } catch (err) {
        toast.error('Failed to load notes');
      } finally {
        setLoading(false);
      }
    };
    fetchNotes();
  }, [ticketId, domain, token]);

  const handleInsert = async () => {
    if (!form.text.trim()) {
      toast.error("Text is required");
      return;
    }

    try {
      const payload = {
        domain,
        createdOn: form.createdOn,
        createdBy: form.createdBy,
        text: form.text.trim()
      };

      await apiClient.post(`/api/tickets/${ticketId}/notes/add`, payload);

      toast.success('Note added');
      setShowForm(false);
      setForm({ createdOn: '', createdBy: '', text: '' });


      const res = await apiClient.post(`/api/tickets/notes`, {
        domain, ticketId });
      setNotes(res.data || []);
    } catch (err) {
      console.error(err.response?.data);
      toast.error('Failed to add note: ' + (err.response?.data?.detail || 'Unknown error'));
    }
  };

  if (loading) return <div className="text-center py-4">Loading notes...</div>;

  return (
    <div>
      <button
        className="btn btn-theme btn-sm me-2"
        onClick={() => setShowForm(!showForm)}
      >
        {showForm ? 'Cancel' : 'Add new record'}
      </button>

      {showForm && (
        <div className="bg-white p-3 border rounded mb-3">

          <div className="row g-3 align-items-end">

            <div className="col-md-2">
              <label className="form-label small fw-semibold mb-1">Created On</label>
              <DatePicker
                selected={form.createdOn ? new Date(form.createdOn) : null}
                onChange={(date) => {
                  setForm({
                    ...form,
                    createdOn: date ? format(date, 'yyyy-MM-dd') : ''
                  });
                }}
                dateFormat="MM/dd/yyyy"
                placeholderText="MM/DD/YYYY"
                className="form-control form-control-sm"
                wrapperClassName="w-100"
                isClearable
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
              />
            </div>

            <div className="col-md-3">
              <label className="form-label small fw-semibold mb-1">Created By</label>
              <input
                className="form-control form-control-sm"
                placeholder="Created By"
                value={form.createdBy}
                onChange={e => setForm({ ...form, createdBy: e.target.value })}
              />
            </div>

            <div className="col-md-7">
              <label className="form-label small fw-semibold mb-1">
                Text <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Enter note text here..."
                value={form.text}
                onChange={e => setForm({ ...form, text: e.target.value })}
              />
            </div>

          </div>

          <div className="mt-3 d-flex gap-2">
            <button className="btn btn-theme btn-sm px-3" onClick={handleInsert}>
              Insert
            </button>
            <button className="btn btn-secondary btn-sm px-3" onClick={() => setShowForm(false)}>
              Cancel
            </button>
          </div>
        </div>
      )}

      <table className="table table-sm table-bordered table-hover">
        <thead>
          <tr>
            <th style={{ fontWeight: 'normal' }}>Created On</th>
            <th style={{ fontWeight: 'normal' }}>Text</th>
            <th style={{ fontWeight: 'normal' }}>Created By</th>
          </tr>
        </thead>
        <tbody>
          {notes.map((note, i) => (
            <tr key={i}>
              <td>{note.dtCreated || '—'}</td>
              <td>{note.szComment || '—'}</td>
              <td>{note.szUserName || '—'}</td>
            </tr>
          ))}
          {notes.length === 0 && (
            <tr>
              <td colSpan={3} className="text-center py-3">No notes found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default NotesTab;